export default "76ef9fc5fb814e2f.png"